<template>
  <div>
    <div class="top">
      <Button type="primary" @click="addItemFn">添加</Button>
    </div>
    <!-- 表格 -->
    <div class="table-div">
      <Table :columns="columns" :data="editItem">
        <template slot-scope="{row}" slot="ImageUrl">
          <div class="rotationImg">
            <img :src="port+row.ImageUrl" alt>
          </div>
        </template>
        <template slot-scope="{row}" slot="action">
          <div class="action-table">
            <a @click="newItemFn(row)">编辑</a>
            <a @click="delItemFn(row)">删除</a>
          </div>
        </template>
      </Table>
    </div>
    <!-- 模态框 -->
    <Modal v-model="showModal" :mask-closable="false" title="添加或编辑团队人员信息">
      <Form ref="newItem" :model="newItem" :label-width="90">
        <FormItem label="图片路径" prop="ImageUrl">
          <!-- <div class="mr hasProgress middleProgress">
            <Upload
              class="mycamera"
              ref="upload"
              type="drag"
              :name="'Image'"
              :show-upload-list="false"
              :on-success="handleSuccess"
              :format="['jpg','jpeg','png']"
              :max-size="2048"
              :on-format-error="handleFormatError"
              :on-exceeded-size="handleMaxSize"
              :before-upload="handleBeforeUpload"
              :action="port+'api/public/Upload/UploadImage/'"
            >
              <div class="icon-box">
                <img v-if="newItem.ImageUrl!=null" :src="port+newItem.ImageUrl">
                <icon v-else type="ios-camera" size="50"></icon>
              </div>
            </Upload>
            <div class="Progress" v-if="showProgress">
              <Progress :percent="percentage" hide-info status="active"></Progress>
            </div>
          </div>-->
          <myUpload
            v-if="showModal"
            :defaultList="ImageUrlList"
            :isImg="'img'"
            @getUrlList="(val)=>getUrlArr(val,'ImageUrl')"
          ></myUpload>
        </FormItem>

        <FormItem label="姓名" prop="Name">
          <Input clearable v-model="newItem.Name"/>
        </FormItem>
        <FormItem label="所在院校" prop="Academy">
          <Input clearable v-model="newItem.Academy"/>
        </FormItem>
        <FormItem label="职称" prop="TheTitle">
          <Input clearable v-model="newItem.TheTitle"/>
        </FormItem>
        <FormItem label="负责内容" prop="TakeCharge">
          <Input clearable v-model="newItem.TakeCharge"/>
        </FormItem>
        <FormItem label="详情介绍" prop="Details">
          <Input clearable type="textarea" v-model="newItem.Details"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showModal=false">取消</Button>
        <Button type="primary" @click="sureEdit('newItem')">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import * as homeConst from "../../../apiconfig/index.js";
import * as homeApi from "../../../api/teacher-api.js";
import myUpload from "../../../components/my-upload";
export default {
  name: "addItem",
  props: ["editItem"],
  components: {
    myUpload: myUpload
  },
  data() {
    return {
      port: homeConst.baseUrl + "/",
      arr: this.editItem,
      columns: [
        { title: "序号", type: "index", align: "center" },
        { title: "图片", slot: "ImageUrl", align: "center" },
        { title: "姓名", key: "Name", align: "center" },
        { title: "所在院校", key: "Academy", align: "center" },
        { title: "职称", key: "TheTitle", align: "center" },
        { title: "负责内容", key: "TakeCharge", align: "center" },
        { title: "详情介绍", key: "Details", align: "center" },
        { title: "可选操作", slot: "action", align: "center" }
      ],
      showModal: false,
      isAdd: true,
      newItem: {},
      ImageUrlList: []
    };
  },
  created() {},
  mounted() {},
  watch: {},

  methods: {
    // 添加
    addItemFn() {
      this.isAdd = true;
      this.newItem = {};
      this.ImageUrlList = [];
      this.showModal = true;
    },
    // 编辑
    newItemFn(row) {
      this.isAdd = false;
      this.newItem = JSON.parse(JSON.stringify(row));
      this.ImageUrlList = [{ url: row.ImageUrl }];
      this.showModal = true;
    },
    // 确认
    sureEdit(name) {
      if (this.isAdd) {
        this.editItem.push(this.newItem);
      } else {
        this.editItem.splice(this.newItem._index, 1, this.newItem);
      }
      this.showModal = false;
      this.$Message.success({
        content: this.isAdd ? "添加成功" : "修改成功",
        duration: 3
      });
    },
    // 删除
    delItemFn(row) {
      this.$Modal.confirm({
        title: "删除专家",
        content: "确认删除" + row.Name,
        onOk: () => {
          this.editItem.splice(row._index, 1);
          this.$Message.success({
            content: "删除成功",
            duration: 3
          });
        }
      });
    },
    // 上传
    getUrlArr(val, str) {
      // this.editItem[str] = val[val.length - 1].url;
      this.$set(this.newItem, "ImageUrl", val[val.length - 1].url);
    }
    // handleBeforeUpload(file) {
    //   this.showProgress = true;
    //   this.percentage = 0;
    // },
    // handleSuccess(res) {
    //   if (res.success) {
    //     this.$set(this.newItem, "ImageUrl", res.msg); //动态添加
    //     this.showProgress = false;
    //     this.percentage = 100;
    //   }
    // },
    // handleFormatError(file) {
    //   this.$Message.error({
    //     content: file.name + "文件格式不正确",
    //     duration: 3
    //   });
    // },
    // 判断文件大小是否符合要求
    // handleMaxSize(file) {
    //   this.$Message.error({
    //     content: file.name + "文件大小超出范围",
    //     duration: 3
    //   });
    // }
  }
};
</script>


